/**
 * Canonical list of Termin (event) categories.
 *
 * Each category has:
 *  - `key`       -- machine identifier (also stored in `events.category`),
 *  - `label`     -- German display name,
 *  - `colorBg`   -- fill colour used for calendar cells (soft pastel
 *                   so multiple categories remain readable next to each other),
 *  - `colorText` -- foreground colour to keep contrast on `colorBg`.
 *
 * The order also drives the order of the chips in the sidebar
 * filter and the dropdown in the admin event editor.
 *
 * Editors can pick any of these from `Termine -> Kategorie`.
 * Unknown values from the DB fall back to "uncategorized".
 */
export interface EventCategory {
  key: string;
  label: string;
  colorBg: string;
  colorText: string;
}

export const EVENT_CATEGORIES: EventCategory[] = [
  { key: "dorfleben",            label: "Dorfleben",            colorBg: "#D8E6CF", colorText: "#2D5A3D" },
  { key: "veranstaltung",        label: "Veranstaltungen",      colorBg: "#A8C99A", colorText: "#1E3F2A" },
  { key: "vereine",              label: "Vereine",              colorBg: "#E2D0AE", colorText: "#7A5A1F" },
  { key: "information",          label: "Informationen",        colorBg: "#C6D6F0", colorText: "#2A4070" },
  { key: "ortsbeiratsitzung",    label: "Ortsbeiratssitzungen", colorBg: "#F5D6B5", colorText: "#7A3F1F" },
  { key: "uncategorized",        label: "Sonstiges",            colorBg: "#E5E5E5", colorText: "#444444" },
];

/**
 * Maps any (possibly historical) backend value to a canonical key.
 * Accepts both German singular/plural variants and the few legacy
 * values used in early seeds.
 */
export function normaliseEventCategory(input: string | null | undefined): string {
  if (!input) return "uncategorized";
  const v = input.toLowerCase().trim();
  if (v.startsWith("dorf")) return "dorfleben";
  if (v.startsWith("veran")) return "veranstaltung";
  if (v.startsWith("verei")) return "vereine";
  if (v.startsWith("info")) return "information";
  if (v.startsWith("ortsbei")) return "ortsbeiratsitzung";
  if (v === "ereignis" || v === "ereignisse") return "dorfleben";
  return EVENT_CATEGORIES.some((c) => c.key === v) ? v : "uncategorized";
}
